export default {
  text_one: 'Zdobądź {{count}} punkt',
  text_few: 'Zdobądź {{count}} punkty',
  text_many: 'Zdobądź {{count}} punktów',
  text_other: 'Zdobądź {{count}} punktów',
};
